import "./App.css";
import "bootstrap/dist/css/bootstrap.css";
import "react-toastify/dist/ReactToastify.css";
import { ToastContainer } from "react-toastify";

import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

import DynaNav from "./components/DynaNav";
import HomePage from "./pages/HomePage";
import MintPage from "./pages/MintPage";
import GalleryPage from "./pages/GalleryPage";
import TokenPage from "./pages/TokenPage";
import HowToPage from "./pages/HowToPage";
import AboutPage from "./pages/AboutPage";
import AdminPage from "./pages/AdminPage";
import FeedbackPage from "./pages/FeedbackPage";

import RouteChangeTracker from "./utils/RouteChangeTracker";
import { WalletSelectionProvider } from "./components/WalletSelectionProvider";
import { initAnalytics } from "./utils/Analytics";

// Static <head> metadata now lives in index.html; pages that need dynamic
// metadata (TokenPage) render <title>/<meta> directly, which React 19 hoists
// into <head> for us — no react-helmet needed.
initAnalytics();

const App = () => (
  <div className="App">
    <ToastContainer
      position="bottom-left"
      autoClose={5000}
      hideProgressBar={false}
      newestOnTop={false}
      closeOnClick
      rtl={false}
      pauseOnFocusLoss
      draggable
      pauseOnHover
    />
    <WalletSelectionProvider>
      <Router>
        <RouteChangeTracker />
        <DynaNav />
        <Routes>
          <Route path="/mint" element={<MintPage />} />
          <Route path="/gallery" element={<GalleryPage />} />
          <Route path="/howto" element={<HowToPage />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/admin" element={<AdminPage />} />
          <Route path="/feedback" element={<FeedbackPage />} />
          <Route path="/token/:tokenId" element={<TokenPage />} />
          <Route path="*" element={<HomePage />} />
        </Routes>
      </Router>
    </WalletSelectionProvider>
  </div>
);

export default App;
